import gql from 'graphql-tag'

const getDevice = gql`
  query getDevice($id: ID!){
	getDevice(id: $id) {
		isTSEStillLive
	}
}
`

export default getDevice
